// Real corporate partner logos, cropped from the foundation's own reference artwork.
import biologicalE from "../assets/partners/biological-e.png";
import cyient from "../assets/partners/cyient.png";
import standardEngineering from "../assets/partners/standard-engineering.png";
import futureproof from "../assets/partners/futureproof.png";
import voith from "../assets/partners/voith.png";
import woodMackenzie from "../assets/partners/wood-mackenzie.png";
import innovapptive from "../assets/partners/innovapptive.png";
import prowessSoft from "../assets/partners/prowess-soft.png";
import { CORPORATE_PARTNERS, NGO_PARTNERS } from "./content";

// Keyed by the exact partner name used in CORPORATE_PARTNERS / NGO_PARTNERS.
export const PARTNER_LOGOS = {
  "Biological E. Limited": biologicalE,
  "Cyient": cyient,
  "Standard Engineering": standardEngineering,
  "Futureproof": futureproof,
  "Voith": voith,
  "Wood Mackenzie": woodMackenzie,
  "Innovapptive": innovapptive,
  "Prowess Soft": prowessSoft,
};

// Static fallback used when the DB-backed /api/partners.php is unreachable.
export const DEFAULT_PARTNERS = {
  corporate: CORPORATE_PARTNERS.map((name) => ({ id: name, name, website: "", logo_path: PARTNER_LOGOS[name] || null })),
  ngo: NGO_PARTNERS.map((name) => ({ id: name, name, website: "", logo_path: PARTNER_LOGOS[name] || null })),
};

// Splits the flat /api/partners.php rows into { corporate, ngo } lists.
export function groupPartnersByType(rows) {
  const corporate = [];
  const ngo = [];
  rows.forEach((row) => {
    (row.partner_type === "ngo" ? ngo : corporate).push(row);
  });
  return { corporate, ngo };
}

